module.exports = __webpack_public_path__ + "img/945.91007155.png";